import { supportEmail } from 'constants/supportEmail';
import { useTranslation } from 'react-i18next';
import styles from './SupportLink.module.scss';

interface SupportLinkProps {
  /** Override the default styling (e.g. to match a surrounding paragraph). */
  className?: string;
}

/**
 * Renders the Spotted Zebra support email as a `mailto:` link.
 *
 * Use standalone, or pass as a `<Trans>` component placeholder — i18next then
 * supplies the link text from the translation, keeping the anchor's `href` and
 * accessible label intact.
 */
export const SupportLink = ({ className }: SupportLinkProps) => {
  const { t } = useTranslation();

  return (
    <a
      className={className ?? styles.link}
      href={`mailto:${supportEmail}`}
      aria-label={t('common.sendEmailTo', { email: supportEmail })}
    >
      {supportEmail}
    </a>
  );
};
